import {
    Box,
    Container,
    Grid,
    GridItem,
    Heading,
    Link,
    List,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function AvisoPrivacidad() {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    return (
        <Stack alignItems="center">
            <Header />
            <Head>
                <title>Aviso de privacidad | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/Aviso-de-privacidad" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/Aviso-de-privacidad"
                    hrefLang="es-mx"
                />
            </Head>
            <Container maxWidth={isGreaterThanMd ? "7xl" : "8xl"} pt={16}>
                <Box mt="24">
                    <Heading
                        as="h1"
                        fontSize={{ md: "4xl", base: "xl" }}
                        textAlign="center"
                        mb="8"
                        color="accent.500"
                        fontWeight="700"
                    >
                        AVISO DE PRIVACIDAD INTEGRAL
                    </Heading>
                    <Box lineHeight="2" mt={12} mb="12">
                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            textAlign="center"
                        >
                            Introducción
                        </Text>
                        <Text as="span" fontWeight="400" fontSize="md" pb={4}>
                            El presente Aviso de Privacidad se expide en base a Normas Oficiales
                            Mexicanas: Lineamientos del Aviso de Privacidad publicado en el Diario
                            Oficial de la Federación (D.O.F.) el día 17 de Enero de 2013, la Ley
                            Federal de Protección de Datos Personales en Posesión de los
                            Particulares y su Reglamento, la Constitución Política de los Estados
                            Unidos Mexicanos y el Convenio 108 del Convenio de Europa y su
                            Protocolo.
                        </Text>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            textAlign="center"
                        >
                            Identificación del responsable
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V. (En lo sucesivo denominado
                            como “EL RESPONSABLE”) con domicilio en Avenida Pablo Neruda número
                            2813, Colonia Providencia 4ta Sección, Ciudad de Guadalajara, Estado de
                            Jalisco, Código Postal 44639 y dominio web www.grupoguia.mx siempre
                            preocupado por la seguridad y protección de datos personales, da a
                            conocer a sus clientes, proveedores, usuarios de plataformas digitales y
                            cualquier otra persona física (TITULAR) que por cualquier motivo
                            entregue o haya entregado información personal, lo siguiente:
                        </Text>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            textAlign="center"
                        >
                            Finalidad del tratamiento
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            <strong>
                                ¿Cuáles y para qué fines utilizaremos sus datos personales?
                            </strong>
                            <br />
                            Los datos personales proporcionados por usted, serán utilizados para las
                            siguientes finalidades necesarias para el servicio que prestamos:
                        </Text>
                        <List.Root ml={8} pb={12}>
                            <List.Item>
                                <strong>Finalidades Primarias:</strong> Son aquellas necesarias para
                                llevar y mantener una relación con usted, para el servicio que
                                solicita.
                            </List.Item>
                            <List.Item>
                                <strong>Finalidades Secundarias:</strong> Son aquellas que no
                                cumplen la condición de finalidad primaria y que no son necesarias
                                para el servicio solicitado, pero que nos permiten y facilitan
                                brindarle una mejor atención.
                            </List.Item>
                            <List.Item>
                                <strong>
                                    Finalidades mercadotécnicas, publicitarias o de prospección
                                    comercial:{" "}
                                </strong>{" "}
                                Son aquellas utilizadas para darnos a conocer en el mercado y captar
                                clientes.{" "}
                            </List.Item>
                        </List.Root>

                        <Grid templateColumns="repeat(2, 1fr)">
                            <GridItem colSpan={2} bg="brand.500">
                                <Text px={8} py={4} fontWeight={700} fontSize="md">
                                    CLIENTES (datos personales de aquellos a los que prestamos
                                    servicios)
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={700} fontSize="sm">
                                    Finalidad primaria
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Identificación oficial (que puede incluir imagen, nombre
                                    completo, domicilio, curp, número de identificación, número de
                                    pasaporte, nacionalidad)
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para verificar y confirmar su identidad, integrar su expediente.
                                    <br />
                                    Dar aviso al SAT.
                                    <br />
                                    Dar cumplimiento a las obligaciones contraídas.
                                    <br />
                                    Gestión de escrituración y formalización notarial.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    CURP
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para identificarlo
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para cumplir con nuestras obligaciones fiscales al facturarle.
                                    <br />
                                    Dar cumplimiento a las obligaciones contraídas.
                                    <br />
                                    Para personalizar nuestra propuestas de servicios profesionales.
                                    <br />
                                    Para darlo de alta en el sistema.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su imagen personal y voz identificable
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Cuando se utilice una plataforma de firmas digitales en la que
                                    se requiera para dar trámite a dicho procedimiento.
                                    <br />
                                    Dar cumplimiento a las obligaciones contraídas.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su firma autógrafa
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Cuando sea necesaria para establecer una relación jurídica o
                                    comercial con usted.
                                    <br />
                                    Dar cumplimiento a las obligaciones contraídas.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su correo personal y teléfono (puede ser número de celular y/o
                                    oficina y/o casa)
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para mantener contacto con usted
                                    <br />
                                    Cuando se utilice una plataforma de firmas digitales, para
                                    enviarle el contrato a firma.
                                    <br />
                                    Para darlo de alta en el sistema.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su domicilio
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para darlo de alta en el sistema.
                                    <br />
                                    Para integrar su expediente.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Correo electrónico
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para darlo de alta en el sistema.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Fecha de nacimiento
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para darlo de alta en el sistema
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                                borderTopColor="white"
                                borderTopWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={400} fontSize="sm">
                                    <strong>Finalidad secundaria:</strong> Usted tiene derecho a no
                                    otorgar otorgar consentimiento para el tratamiento de sus datos
                                    personales para fines secundarios.
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su correo electrónico
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para enviarle información general sobre nuestros servicios.
                                    <br />
                                    Para enviarle encuesta de servicio que nos permita mejorar y
                                    conocer su experiencia al trabajar con nosotros.
                                    <br />
                                    Para promover nuestros servicios y productos.
                                    <br />
                                    <br />
                                    Notificarle sobre nuevos servicios o productos que tengan
                                    relación con los ya contratados o sobre cambios en éstos mismos.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su número de celular
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para enviarle información general sobre nuestros servicios.
                                    <br />
                                    Para enviarle encuesta de servicio que nos permita mejorar y
                                    conocer su experiencia al trabajar con nosotros.
                                    <br />
                                    Para promover nuestros servicios y productos.
                                    <br />
                                    <br />
                                    Notificarle sobre nuestros servicios o productos que tengan
                                    relación con los ya contratados o sobre cambios en estos mismos.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para identificarle en encuestas que nos permitan evaluar
                                    nuestros servicios.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Edad
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para realizar estudios mercadológicos
                                </Text>
                            </GridItem>
                        </Grid>

                        <Grid templateColumns="repeat(2, 1fr)" mt={16}>
                            <GridItem colSpan={2} bg="brand.500">
                                <Text px={8} py={4} fontWeight={400} fontSize="md">
                                    <strong>Proveedores:</strong> (datos personales de aquellos que
                                    nos proporcionan productos o servicios)
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={700} fontSize="sm">
                                    Finalidad primaria
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Identificarlo
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Imagen y voz identificable
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Cuando de común acuerdo se firme a través de una plataforma de
                                    firmas electrónicas que exijan dichos datos para identificarle.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Firma autógrafa
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para ser plasmada en documentos necesarios para iniciar una
                                    relación jurídica o comercial.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                                borderTopColor="white"
                                borderTopWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={400} fontSize="sm">
                                    <strong>Finalidad secundaria:</strong> Usted tiene derecho a no
                                    otorgar consentimiento para el tratamiento de sus datos
                                    personales para fines secundarios.
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su correo electrónico
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para enviarle información general sobre nuestros servicios.
                                    <br />
                                    Para enviarle encuestas que nos permitan evaluar nuestros
                                    servicios.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para identificarle en encuestas que nos permitan evaluar
                                    nuestros servicios.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su número de celular
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para enviarle información general sobre nuestros servicios.
                                    <br />
                                    Para enviarle encuestas que nos permitan evaluar nuestros
                                    servicios.
                                </Text>
                            </GridItem>
                            <GridItem colSpan={2} bg="#CACACA">
                                <Text px={8} py={4} fontWeight={400} fontSize="sm">
                                    Por regla general, no serán recabados datos personales distintos
                                    a los necesarios para entablar una relación jurídica o
                                    comercial.
                                </Text>
                            </GridItem>
                        </Grid>

                        <Grid templateColumns="repeat(2, 1fr)" mt={16} mb={16}>
                            <GridItem colSpan={2} bg="brand.500">
                                <Text px={8} py={4} fontWeight={400} fontSize="sm">
                                    <strong>EMPLEADOS O ASPIRANTES A EMPLEADOS:</strong> (datos
                                    personales de aquellos que tengan o pretendan tener una relación
                                    laboral con el responsable)
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={700} fontSize="sm">
                                    PRIMARIAS
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Identificación oficial (que puede incluir imagen, nombre
                                    completo, domicilio, curp, número de identificación, número de
                                    pasaporte, nacionalidad)
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para identificarlo
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para plasmarlo de manera correcta en el contrato individual de
                                    trabajo o cualquier otra relación jurídica que adquiera el
                                    responsable.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Contactos de referencia
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para solicitar referencias y confirmar lo que usted nos ha
                                    manifestado en entrevista.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su correo electrónico
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para mantener contacto con usted durante la etapa de entrevista.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su comprobante de domicilio, acta de nacimiento, cedula
                                    profesional, titulo de estudios, registro federal de
                                    contribuyentes, curriculum vitae
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para integrar su expediente.
                                    <br />
                                    Para valorar sus conocimientos y aptitudes en la vacante para la
                                    que está aplicando.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su cuenta de banco
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para hacerle transferencia o deposito de su salario y
                                    prestaciones de ley en los términos indicados en el contrato que
                                    corresponda.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Información sobre su crédito Infonavit
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para conocer si existe alguna obligación de retención de su
                                    nómina.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Firma autógrafa
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para hacer constar su consentimiento o su intervención.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Número de teléfono para emergencias
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para llamar a ese número ante una emergencia que requiere
                                    informar a una tercera persona.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Número de celular
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para estar en contacto durante la etapa de entrevista.
                                    <br />
                                    Para estar en contacto en una relación laboral.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                                borderTopColor="white"
                                borderTopWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={400} fontSize="sm">
                                    <strong>Finalidad secundaria:</strong> Usted tiene derecho a no
                                    otorgar consentimiento para el tratamiento de sus datos
                                    personales para fines secundarios.
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su imagen
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para felicitarlo públicamente a través de chats el día de su
                                    cumpleaños.
                                    <br />
                                    Para analizar distintas respuestas realizadas previamente para
                                    analizar si cumple con los requisitos para ser entrevistado y/o
                                    contratado.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su voz identificable
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para analizar distintas respuestas realizadas previamente para
                                    analizar si cumple con los requisitos para ser entrevistado y/o
                                    contratado.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su número de celular
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para integrarle a chats que le permitan conocer información
                                    relacionada con la ubicación de trabajo, como por ejemplo la
                                    llegada de proveedores de alimentos.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Nombre completo
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para identificarle en encuestas que nos permitan evaluar su
                                    trabajo.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={2}
                                bg="#FFE682"
                                borderBottomColor="white"
                                borderBottomWidth={1}
                                borderTopColor="white"
                                borderTopWidth={1}
                            >
                                <Text px={8} py={4} fontWeight={700} fontSize="sm">
                                    FINALIDAD MERCADOTECNICA, PUBLICITARIA O DE PROSPECCIÓN
                                    COMERCIAL
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="accent.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Dato
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="accent.500" borderRightColor="#B1B1B1">
                                <Text color="white" fontWeight={600} px={6} py={2}>
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su imagen identificable
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#F6F6F6" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para dar testimonio de nuestro trabajo subiendo a nuestras redes
                                    sociales y/o sitios web fotografías y/o videos donde usted se
                                    identifique.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Su voz
                                </Text>
                            </GridItem>
                            <GridItem colSpan={1} bg="#E4E4E4" borderRightColor="#B1B1B1">
                                <Text fontSize="sm" fontWeight={400} px={8} py={6}>
                                    Para dar testimonio de nuestro trabajo subiendo a nuestras redes
                                    sociales y/o sitios web fotografías y/o videos donde se escuche
                                    su voz identificable.
                                </Text>
                            </GridItem>
                        </Grid>

                        <Text fontWeight="400" fontSize="md" pb={4}>
                            Cuando sus datos sean recabados de manera directa en el domicilio
                            señalado por el responsable, usted puede indicar no desea el uso de los
                            datos con finalidades secundarias y/o de mercadotécnica, publicitaria o
                            de prospección comercial, pudiendo presentar en ese momento un escrito,
                            manifestando lo anterior. Solicite el formato correspondiente a quien lo
                            atienda.
                            <br />
                            <br />
                            Si sus datos se recaban a través de plataformas digitales, podrá negar
                            el uso para estos fines.
                            <br />
                            <br />
                            La negativa para el uso de sus datos personales para estas finalidades
                            no podrá ser un motivo para que le neguemos los servicios y productos
                            que solicita o contrata con nosotros.
                        </Text>

                        <Box borderRadius="md" borderWidth={1} borderColor="#6A6A6A" p={4}>
                            <Text fontWeight="400" fontSize="md">
                                Cuando el aviso de privacidad no se haga del conocimiento del
                                titular de manera personal o directa, como por ejemplo en su envío
                                por correo postal, el titular tiene un plazo de 5 cinco días hábiles
                                para que, de ser el caso, manifieste su negativa para el tratamiento
                                o aprovechamiento de sus datos personales en las finalidades
                                secundarias y/o mercadotécnicas, publicitaria o de prospección
                                comercial.
                            </Text>
                        </Box>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            pt={14}
                            textAlign="center"
                        >
                            Datos sensibles
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            Por regla general, no recabamos datos sensibles, entendiéndose como
                            tales aquellos que afectan a su esfera más íntima, o cuyo uso indebido
                            de nuestra parte pueda dar origen a discriminación o conlleve un riesgo
                            para usted. En particular se considerarán sensibles aquellos datos que
                            puedan revelar aspectos sobre su origen racial o étnico, su estado de
                            salud presente o futura, su información genética, sus creencias
                            religiosas, filosóficas o morales, su afiliación sindical, sus opiniones
                            políticas o su preferencia sexual.
                            <br />
                            <br />
                            En caso de ser necesario solicitar información considerada sensible,
                            será necesaria su autorización de manera expresa y por escrito. Lo
                            anterior no será aplicable cuando su tratamiento sea necesario por estar
                            previsto en una ley, dichos datos figuren en fuentes de acceso público,
                            los datos se encuentren sometidos a un procedimiento previo de
                            disociación, tenga el propósito de cumplir obligaciones derivadas de una
                            relación jurídica entre el titular y el responsable, exista una
                            situación de emergencia que pueda potencialmente dañar su persona o sus
                            bienes y en general los casos establecidos por el artículo 10 de la Ley
                            Federal de Protección de Datos Personales en Posesión de los
                            Particulares.
                        </Text>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            pt={14}
                            textAlign="center"
                        >
                            Acciones concretas para menores de edad y personas en condición de
                            discapacidad
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            Reconocemos la vulnerabilidad de los datos personales de menores de edad
                            y personas en condición de discapacidad. Nuestro esfuerzo será siempre
                            proporcionar asistencia a las personas en esta condición para efecto de
                            que reciban el servicio de su preferencia, bajo una expectativa de
                            equidad razonable.
                            <br />
                            <br />
                            En el caso de menores de edad y personas declaradas en estado de
                            interdicción tomamos medidas específicas como son:
                            <br />
                            La obtención del consentimiento de los padres y tutores por medio de una
                            carta consentimiento que deberá ser firmada de manera autógrafa. Previo
                            a la firma de dicha carta deberá acreditar su personalidad. En general
                            deberá presentar cualquier documento legal que compruebe su facultad
                            como representante del menor o persona en estado de interdicción.
                        </Text>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            pt={14}
                            textAlign="center"
                        >
                            Cámaras de seguridad
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            Contamos con cámaras de vigilancia en nuestro domicilio. Usted será
                            grabado únicamente con fines de seguridad para usted y de las personas
                            que nos visiten.
                        </Text>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            pt={14}
                            textAlign="center"
                        >
                            Transferencia de datos
                        </Text>
                        <Text fontWeight="400" fontSize="md" pb={4}>
                            <strong>¿A quién transferimos sus datos?</strong>
                            <br />
                            Le informamos que en primera instancia, EL RESPONSABLE no hace
                            transferencia de sus datos personales. Sin embargo, existen algunos
                            supuestos en los que debemos transferir la totalidad o parcialidad de
                            datos para cumplir de manera eficaz con el fin para el que usted nos ha
                            contratado o solicitado, o bien, para gestionar el cumplimiento de sus
                            obligaciones, en cuyo caso, la persona que recibe la información deberá
                            apegarse a los lineamientos de este Aviso de Privacidad. El responsable
                            puede hacer transferencia de sus datos a los siguientes:
                        </Text>

                        <Grid
                            templateColumns={isGreaterThanMd ? "repeat(4, 1fr)" : "repeat(3, 1fr)"}
                            mt={16}
                            mb={14}
                        >
                            <GridItem
                                colSpan={1}
                                bg="brand.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    px={isGreaterThanMd ? 8 : 2}
                                    py={6}
                                    fontWeight={700}
                                    fontSize={isGreaterThanMd ? "md" : "sm"}
                                >
                                    Destinatario de los datos personales
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="brand.500"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    px={8}
                                    py={isGreaterThanMd ? 6 : 2}
                                    fontWeight={700}
                                    fontSize={isGreaterThanMd ? "md" : "sm"}
                                >
                                    País
                                </Text>
                            </GridItem>
                            <GridItem colSpan={isGreaterThanMd ? 2 : 1} bg="brand.500">
                                <Text
                                    px={8}
                                    py={isGreaterThanMd ? 6 : 2}
                                    fontWeight={700}
                                    fontSize={isGreaterThanMd ? "md" : "sm"}
                                >
                                    Finalidad
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Redes sociales Facebook, Google, Waze, LinkedIn
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Estados Unidos
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={isGreaterThanMd ? 2 : 1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Para conocer sus comentarios respecto a la información que
                                    publiquemos en redes.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Instituto Mexicano del Seguro Social
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    México
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={isGreaterThanMd ? 2 : 1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Para el cumplimiento de las obligaciones sanitarias que nos
                                    impone la Legislación de la materia aplicable.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Su aseguradora
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    México
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={isGreaterThanMd ? 2 : 1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    En su caso, para realizar los trámites correspondientes para la
                                    intervención del seguro.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Su banco
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    México
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={isGreaterThanMd ? 2 : 1}
                                bg="#E4E4E4"
                                borderRightColor="#B1B1B1"
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    En su caso, para realizar el cobro de nuestros servicios con
                                    tarjeta de crédito o débito.
                                </Text>
                            </GridItem>

                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    CLUB DE RENTAS LMS S.A.P.I. DE C.V.
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={1}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                                borderRightWidth={1}
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    México
                                </Text>
                            </GridItem>
                            <GridItem
                                colSpan={isGreaterThanMd ? 2 : 3}
                                bg="#F6F6F6"
                                borderRightColor="#B1B1B1"
                            >
                                <Text
                                    fontSize={isGreaterThanMd ? "sm" : "xs"}
                                    fontWeight={400}
                                    px={8}
                                    py={6}
                                >
                                    Transferimos su nombre completo y número de teléfono cuando
                                    decida utilizar los servicios GUIARENT para que lo contacten en
                                    forma directa.
                                </Text>
                            </GridItem>
                        </Grid>

                        <Text
                            color="accent.500"
                            fontWeight="400"
                            fontSize="xl"
                            pb={6}
                            pt={14}
                            textAlign="center"
                        >
                            Derechos ARCO
                        </Text>
                        <Text fontWeight="400" fontSize="md" mb={10}>
                            ¿Cómo puede ejercer sus derechos ARCO?
                            <br />
                            Usted tiene derecho a conocer qué datos personales tenemos, para qué los
                            utilizamos y las condiciones de uso que les damos.
                            <br />
                            <br />
                            Usted puede en cualquier momento revocar el consentimiento que, en su
                            caso, nos haya otorgado para el tratamiento de sus datos personales. Sin
                            embargo, es importante que tenga en cuenta que no en todos los casos
                            podremos atender su solicitud o concluir el uso de forma inmediata, ya
                            que es posible que por alguna obligación legal requiramos seguir
                            tratando sus datos personales. Asimismo, usted deberá considerar que,
                            para los fines primarios, la revocación de su consentimiento implicará
                            que no le podamos seguir prestando el servicio que nos solicitó, o la
                            conclusión de su relación con nosotros.
                            <br />
                            Usted podrá ejercer su derecho de revocación, así como sus derechos
                            ARCO, proporcionando un escrito al encargado de datos personales
                            mediante correo electrónico a la dirección:
                            contactojuridico@grupoguia.mx o bien, entregando dicho escrito
                            directamente en nuestras instalaciones en el domicilio mencionado al
                            presente “Aviso” con atención: DEPARTAMENTO JURIDICO.
                            <br />
                            <br />
                            Dicho documento deberá contener, como mínimo: Fecha, nombre completo,
                            domicilio (Calle, Colonia, Código Postal, Municipio o Delegación, Ciudad
                            y Estado), Teléfono, Correo Electrónico, la acción específica respecto a
                            sus datos que solicita al responsable y el motivo, identificación
                            oficial y en caso de ser representante legal, el documento que acredite
                            su personalidad.
                            <br />
                            <br />
                            Una vez recibida su solicitud, el responsable dará respuesta en un
                            término no mayor a 20 días. Dicha respuesta será enviada al correo o
                            domicilio que usted haya proporcionada en su solicitud.
                            <br />
                            <br />
                            El presente aviso de privacidad puede sufrir modificaciones, cambios o
                            actualizaciones derivadas de nuevos requerimientos legales; de nuestras
                            propias necesidades por los productos o servicios que ofrecemos, de
                            nuestras prácticas de privacidad, de cambios en nuestro modelo de
                            negocio, o por otras causas.
                            <br />
                            <br />
                            Nos comprometemos a mantenerlo informado sobre los cambios que pueda
                            sufrir el presente aviso de privacidad, a través de nuestra página web{" "}
                            <Link
                                ml={1}
                                href="https://grupoguia.mx/marketing"
                                color="#2483C5"
                                external
                            >
                                https://grupoguia.mx/marketing
                            </Link>
                            <br />
                            <br />
                            En caso de realizar cambios o actualizaciones al presente Aviso, el
                            responsable los publicará de manera generalizada en comunicados
                            colocados en el domicilio mencionado en este documento. En caso de que
                            usted así lo solicite por escrito, le enviaremos nuestras
                            actualizaciones al correo electrónico que usted nos proporcione.
                            <br />
                            <br />
                            Para cualquier asunto o duda relacionada con este Aviso de Privacidad,
                            puede contactarnos al correo electrónico{" "}
                            <Link
                                ml={1}
                                color="#2483C5"
                                href="mailto:contactojuridico@grupoguia.mx"
                            >
                                contactojuridico@grupoguia.mx
                            </Link>{" "}
                            o acudir a nuestras instalaciones.
                            <br />
                            <br />
                            Fecha de última actualización del presente Aviso de Privacidad 22 de
                            septiembre de 2022.
                            <br />
                            En todo caso, recomendamos visite la página de internet frecuentemente.
                        </Text>
                    </Box>
                </Box>
            </Container>
            <Footer esGuiaRent={false} />
        </Stack>
    );
}
